import { createSlice } from '@reduxjs/toolkit';

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: {
    displayOnboarding: undefined,
    hasClosedCompleteOnboardingModal: false,
    hasSubmittedOnboarding: false,
    status: '',
    touring: false,
  },
  reducers: {
    updateDisplayOnboarding: (state, action) => {
      state.displayOnboarding = action.payload;
    },
    updateOnboardingStatus: (state, action) => {
      state.status = action.payload;
    },
    setHasClosedCompleteOnboardingModal: (state, action) => {
      state.hasClosedCompleteOnboardingModal = action.payload;
    },
    setTouring: (state, action) => {
      state.touring = action.payload;
    },
    updateOnboardingSubmit: (state, action) => {
      state.hasSubmittedOnboarding = action.payload;
    },
    onResetOnboarding: (state, action) => {
      state.displayOnboarding = undefined;
      state.hasClosedCompleteOnboardingModal = false;
      state.hasSubmittedOnboarding = false;
      state.status = '';
      state.touring = false;
    },
  },
});

export const {
  updateOnboardingStatus,
  setHasClosedCompleteOnboardingModal,
  updateOnboardingSubmit,
  setTouring,
  onResetOnboarding,
  updateDisplayOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;

// if onboarding is complete and they are not on the onboarding page
// if they are in the tour don't show onboarding success
// if they are out of the tour show onboarding success
